module.exports = __webpack_public_path__ + "ae709b06b3396ae4faa0426a03843a11.svg";